import styled from "styled-components";

export const BoxForm = styled.div<{ hasResponse: boolean }>`
  .form-comment {
    padding: ${({ hasResponse }) => (hasResponse ? '1rem' : '1rem 0')};

    .closed {
      display: flex;
      align-items: center;
      justify-content: flex-end;
      span {
        cursor: pointer;
        display: inline-block;
        ${({ theme }) => ({ ...theme.size.xxs })}
        color: ${({ theme }) => theme.colors.secondaryBackgroundColor}
      }

      .icon {
        margin-right: 0.2rem;
      }
    }
  }
`

export const BoxComment = styled.div`
  margin: 1rem 0;
  padding: 1rem 0;
  background-color: ${({ theme }) => theme.colors.palette.neutral200};
`
export const BoxCommentChildren = styled.div`
  padding-left: 2rem;
`
